<template>
    <div>
        <transition name="fade" mode="out-in" v-if="permisos['abonos.vender']">
            <div key="1" id="paso-1">
                <PasoUnoComponent
                    ref="pasoUno"
                    :precios="precios"
                    :disabled="paso > 1"
                    @terminado="bloquearAbonos"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="2" id="paso-2" v-if="paso >= 2">
                <hr class="pb-2">
                <PasoDosComponent
                    :datos_compradores="datos_compradores" 
                    :precios="precios" 
                    :disabled="paso >= 3"
                    @cambiarButacas="borrarSesion"
                    @borrado="eliminarComprador"
                    @actualizar="actualizar"
                    @terminado="finalizarPasoDos"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="3" id="paso-3" v-if="paso >= 3">
                <hr>
                <PasoTresComponent
                    :datos_compradores="datos_compradores"
                    :disabled="paso >= 4"
                    @terminado="finalizarPasoTres"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" id="paso-4" v-if="paso >= 4">
                <hr>
                <PasoCuatroComponent
                    ref="pasoCuatro"
                    :datos_compradores="datos_compradores"
                    :datos_compra="datos_compra"
                    @reiniciar="reiniciar"
                    @procesar="procesarCompra"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import PasoUnoComponent from '../../stepper/abonos/sin-recinto/PasoUnoComponent.vue';
import PasoDosComponent from '../../stepper/abonos/sin-recinto/PasoDosComponent.vue';
import PasoTresComponent from '../../stepper/abonos/sin-recinto/PasoTresComponent.vue';
import PasoCuatroComponent from '../../stepper/abonos/common/PasoCuatroComponent.vue';

export default {
    data() {
        return {
            paso: 1,
            precios: [],
            sesiones: [],
            datos_compra: null,
            precios_formatted: [],
            datos_compradores: [],
            session_id: null
        }
    },
    methods: {
        getPrecios() {
            this.loading = true;

            const params = {
                filters :  {},
                lista_id: this.$store.getters.getListaId
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.sin-recinto'), params).then(res => {
                this.precios = res.data.data;
                this.precios.forEach(precio => {
                    this.$set(precio, 'units', 0);
                });
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        finalizarPasoUno() {
            this.paso = 2;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + 2);
            });
        },
        finalizarPasoDos(datos_compradores) {
            this.datos_compradores = datos_compradores;
            this.paso = 3;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + 3);
            });
        },
        finalizarPasoTres(datos_compra) {
            this.datos_compra = datos_compra;
            this.paso = 4;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + 4);
            });
        },
        bloquearAbonos() {
            if (this.precios_formatted.length === 0) {
                this.precios.forEach(precio => {
                    if (precio.units > 0) {
                        this.precios_formatted.push({
                            id: precio.id,
                            cantidad: precio.units
                        });
                    }
                });
            }

            if (this.$refs.pasoUno) {
                this.$refs.pasoUno.loading = true;
            }

            const params = {
                filters :  {},
                lista_id: this.$store.getters.getListaId,
                precios_abonos: this.precios_formatted
            };

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.sin-recinto.bloquear'), params).then(res => {
                this.sesiones = res.data.sesiones;
                this.session_id = res.data.session_id;
                sessionStorage.setItem('session_id', res.data.session_id);
                this.setDatosCompradores();
                if (this.$refs.pasoUno) {
                    this.finalizarPasoUno();
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                if (this.$refs.pasoUno) {
                    this.$refs.pasoUno.loading = false;
                }
            });
        },
        setDatosCompradores() {
            if (this.sesiones.length) {
                for (let i = 0; i < this.sesiones.length; i++) {
                    const tipo_abono = this.precios.find(precio => precio.id === this.sesiones[i].precio_id);
                    
                    if (this.datos_compradores[i]) {
                        this.$set(this.datos_compradores[i], 'id', this.sesiones[i].id);
                    } else {
                        this.datos_compradores.push({
                            id: this.sesiones[i].id, 
                            area: tipo_abono,
                            apellidos: '',
                            dni: '',
                            es_nuevo: true,
                            nombre: '',
                            precio: '', 
                            precios: tipo_abono.descuentos, 
                            telefono: '',
                            url_imprimir: '',
                            n_abonado_antiguo: '',
                            email: '',
                            domicilio: '',
                            cp: ''
                        });
                    }
                }
            }
        },
        eliminarComprador(index) {
            this.datos_compradores.splice(index, 1);

            this.datos_compradores.forEach(comprador => {
                const precio = this.precios_formatted.find(p => p.id === comprador.area.id);
                
                if (precio) {
                    const cantidadRestante = this.datos_compradores.filter(c => c.area.id === precio.id).length;
                    precio.cantidad = cantidadRestante;
                }
            });

            this.precios_formatted = this.precios_formatted.filter(precio => {
                return this.datos_compradores.some(comprador => comprador.area.id === precio.id);
            });

            const todosBorrados = this.datos_compradores.length === 0;

            this.borrarSesion(null, todosBorrados);

            setTimeout(() => {
                this.bloquearAbonos();
            }, 500);
        },
        procesarCompra() {
            this.datos_compradores.forEach(comprador => {
                comprador.descuento_id = comprador.precio.id;
            });

            const params = {
                lista_id: this.lista_id,
                session_id: this.session_id,
                metodo_pago: this.datos_compra.metodo_pago,
                datos_compradores: this.datos_compradores
            };

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.sin-recinto.alta'), params).then(res => {
                this.$refs.pasoCuatro.compra_finalizada = true;
                this.$refs.pasoCuatro.urls_imprimir = res.data.pdfs;
                this.$refs.pasoCuatro.url_factura = res.data.url_factura;
                this.$refs.pasoCuatro.error = null;
            }).catch(error => {
                this.$refs.pasoCuatro.error = error.response.data.message;
            });
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100);
        },
        borrarSesion(paso, reload = false) {
            if (paso) {
                this.paso = paso;
            }
            this.$emit('borrarSesion', reload);
        },
        actualizar(datos) {
            this.datos_compradores = datos;
        },
        reiniciar() {
            this.borrarSesion(1, true);
        }
    },
    computed: {
        lista_id() {
            return this.$store.getters.getListaId;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        }
    },
    created() {
        this.getPrecios();
    },
    components: {
        PasoUnoComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent
    }
}
</script>